import React from 'react'
import B1WhyMain from '../../B1Page/B1Why/B1WhyMain'
import B1WhyHead from '../../B1Page/B1Why/B1WhyHead'
import "./../../A2Page/A2Page.css"

const B2Why = () => {
  return (
    <div className='a2WhyContainer'>
      <B1WhyHead/>
      <B1WhyMain/>
    </div>
  )
}

export default B2Why
